import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardContent className="pt-8 pb-8 text-center space-y-6">
          <XCircle className="w-16 h-16 mx-auto text-orange-500" />
          <div>
            <h2 className="text-xl font-semibold mb-2">Payment Cancelled</h2>
            <p className="text-muted-foreground">
              Your payment was cancelled. No charges were made.
            </p>
          </div>
          <div className="space-y-2">
            <Button className="w-full" onClick={() => navigate('/buy-credits')}>
              Try Again
            </Button>
            <Button variant="outline" className="w-full" onClick={() => navigate('/dashboard')}>
              Go to Dashboard
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
